export default "__VITE_ASSET__Bl49YY9L__"